export default __webpack_public_path__ + "media/images/house-image-a1915b27a5c283f30cc03345cc5c097f.jpg";